/**
 * Decimal adjustment of a number.
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Math/ceil
 * */

const shiftBack = (value: number, exp: number): number => +`${value}e${exp}`;

const shift = (value: number, type: string, exp: number): number => Math[type](+`${value}e${-exp}`);

const decimalAdjust = (type: string, value: any, exp: number): number => {
  if (value === null || Number.isNaN(Number.parseFloat(value)) || !(typeof exp === 'number' && exp % 1 === 0)) {
    return NaN;
  }

  return shiftBack(shift(+value, type, exp), +exp);
};

export const roundCeil = (value: number | unknown, exp: number): number => decimalAdjust('ceil', value, exp);
export const roundFloor = (value: number | unknown, exp: number): number => decimalAdjust('floor', value, exp);
export const roundHalfUp = (value: number | unknown, exp: number): number => decimalAdjust('round', value, exp);
